var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Button',{attrs:{"icon":"far fa-edit","label":_vm.$t('edit')},on:{"click":function($event){return _vm.setActive(_vm.widget.id)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }